import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Calendar, TrendingUp } from 'lucide-react';
export function Slide6Expansion() {
  const strategy = [{
    scenario: 'Single Congress',
    leads: '12',
    cost: 'Baseline'
  }, {
    scenario: '2-Congress Bundle',
    leads: '25-30',
    cost: '-30%'
  }, {
    scenario: '4-Congress Bundle',
    leads: '50-60+',
    cost: '-60-70%'
  }, {
    scenario: 'With Email/Social',
    leads: '75-100+',
    cost: '-70%'
  }];
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full" data-id="element-676">
      <div className="mb-8 border-b border-slate-100 pb-6" data-id="element-677">
        <div className="text-sm font-bold text-snakker-purple uppercase tracking-widest mb-2" data-id="element-678">
          07 / Expansion
        </div>
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-2" data-id="element-679">
          Multiply Success
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-680">
          The campaign established a replicable, high-performing framework ready
          for scale.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 flex-1 items-stretch" data-id="element-681">
        {/* Multi-Congress Strategy */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="lg:col-span-7 bg-white rounded-3xl p-6 border border-slate-100 shadow-sm flex flex-col" data-id="element-682">
          <div className="flex items-center gap-3 mb-4" data-id="element-683">
            <div className="p-2.5 bg-minerva-blue/10 rounded-xl" data-id="element-684">
              <TrendingUp className="w-5 h-5 text-minerva-blue" data-id="element-685" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-686">
              Multi-Congress Strategy: 3-4x Lead Volume
            </h3>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-687">
            {strategy.map((row, i) => <div key={i} className={`p-4 rounded-xl border ${i === 0 ? 'bg-slate-50 border-slate-200' : 'bg-white border-slate-100 shadow-sm'}`} data-id="element-688">
                <div className="text-sm font-semibold text-slate-600 mb-1" data-id="element-689">
                  {row.scenario}
                </div>
                <div className="flex justify-between items-end" data-id="element-690">
                  <div className="text-2xl font-bold text-minerva-blue" data-id="element-691">
                    {row.leads}{' '}
                    <span className="text-xs font-normal text-slate-400" data-id="element-692">
                      leads
                    </span>
                  </div>
                  <div className="text-sm font-bold text-emerald-600" data-id="element-693">
                    {row.cost}{' '}
                    <span className="text-xs font-normal text-slate-400" data-id="element-694">
                      CPL
                    </span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-minerva-blue/5 p-3 rounded-xl border border-minerva-blue/10 text-sm text-slate-700" data-id="element-695">
            <strong data-id="element-696">Key Advantage:</strong> Reusable framework means minimal
            incremental production cost.
          </div>
        </motion.div>

        {/* Year-Long Platform */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4
      }} className="lg:col-span-5 bg-slate-50 rounded-3xl p-6 border border-slate-200 flex flex-col" data-id="element-697">
          <div className="flex items-center gap-3 mb-4" data-id="element-698">
            <div className="p-2.5 bg-indigo-100 rounded-xl" data-id="element-699">
              <Calendar className="w-5 h-5 text-indigo-600" data-id="element-700" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-701">
              Year-Long Thought Leadership
            </h3>
          </div>

          <div className="space-y-3 flex-1 flex flex-col justify-center" data-id="element-702">
            <div className="flex items-center gap-4 bg-white p-3 rounded-xl border border-slate-100 shadow-sm" data-id="element-703">
              <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold flex items-center justify-center shrink-0" data-id="element-704">
                1
              </div>
              <div data-id="element-705">
                <h4 className="font-bold text-slate-800 text-sm" data-id="element-706">
                  Post-Congress Mashup
                </h4>
                <p className="text-xs text-slate-500" data-id="element-707">
                  Re-engage participants with exclusive insights.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 bg-white p-3 rounded-xl border border-slate-100 shadow-sm" data-id="element-708">
              <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold flex items-center justify-center shrink-0" data-id="element-709">
                2
              </div>
              <div data-id="element-710">
                <h4 className="font-bold text-slate-800 text-sm" data-id="element-711">
                  Next Congress Replication
                </h4>
                <p className="text-xs text-slate-500" data-id="element-712">
                  Deploy proven model with European audience.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 bg-white p-3 rounded-xl border border-slate-100 shadow-sm" data-id="element-713">
              <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-bold flex items-center justify-center shrink-0" data-id="element-714">
                3
              </div>
              <div data-id="element-715">
                <h4 className="font-bold text-slate-800 text-sm" data-id="element-716">
                  Annual Industry Pulse
                </h4>
                <p className="text-xs text-slate-500" data-id="element-717">
                  Position Minerva as the industry authority.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}